import {storeKinds} from './stores'

/*
 * Speed dial activities change based on the current month, rotating
 * out sports that are no longer in season.
 */
export const speedDialActivities = {
  0: ['M', 'BK', 'FB', 'BB', 'WR', 'SC', 'LC', 'HC'],
  1: ['M', 'BB', 'BK', 'FB', 'SW', 'WR', 'HC', 'GY'],
  2: ['M', 'BB', 'FB', 'SW', 'BK', 'HC', 'GY', 'TN'],
  // TODO(wes): Restore on 3/8
  // 1: ['M', 'BB', 'BK', 'FB', 'LC', 'WR', 'SC', 'TF'],
  // 2: ['M', 'BB', 'FB', 'LC', 'BK', 'TF', 'SC', 'TN'],
  3: ['M', 'BB', 'FB', 'LC', 'TF', 'BK', 'TN', 'SC'],
  4: ['M', 'FB', 'BB', 'LC', 'BK', 'TF', 'SC', 'VB'],
  5: ['M', 'FB', 'BB', 'BK', 'LC', 'SC', 'HC', 'TF'],
  6: ['M', 'FB', 'BK', 'BB', 'SC', 'CC', 'LC', 'VB', 'HC'],
  7: ['M', 'FB', 'SC', 'VB', 'BK', 'BB', 'CC', 'TN'],
  8: ['M', 'FB', 'VB', 'SC', 'BK', 'BB', 'CC', 'SB'],
  9: ['M', 'FB', 'BK', 'SC', 'BB', 'VB', 'WR', 'HC'],
  10: ['M', 'FB', 'BK', 'WR', 'BB', 'SC', 'HC', 'LC'],
  11: ['M', 'FB', 'BK', 'BB', 'SC', 'WR', 'HC', 'LC']
}

export const speedDialActivityNames = {
  BB: 'Baseball',
  BK: 'Basketball',
  CC: 'Cross Country',
  FB: 'Football',
  GY: 'Gymnastics',
  HC: 'Hockey',
  LC: 'Lacrosse',
  SC: 'Soccer',
  SW: 'Swimming',
  TF: 'Track & Field',
  TN: 'Tennis',
  VB: 'Volleyball',
  WR: 'Wrestling,'
}

const activityOrders = {
  school: [
    'Mascot',
    'Sports',
    'Sports-Men',
    'Sports-Women',
    'Family',
    'Academic',
    'Clubs',
    'Class',
    'Grade',
    'Alumni',
    'Admin',
    'Events',
    'Coaching',
    'Level',
    'Football',
    'Cheerleading',
    'Basketball',
    'Baseball',
    'Soccer',
    'Track & Field',
    'Volleyball',
    'Band',
    'Phys Ed',
    'Fun'
  ],
  team: [
    'Mascot',
    'Family',
    'Player',
    'Coaching',
    'Admin',
    'Booster',
    'Fun',
    'Level'
  ],
  college: [
    'Mascot',
    'Sports',
    'Sports-Men',
    'Sports-Women',
    'Athletics',
    'ATHLETICS-MEN',
    'ATHLETICS-WOMEN',
    'Alumni',
    'Family',
    'School',
    'Departments',
    'Campus Life',
    'IMA'
  ],
  greek: ['Nickname', 'Greek', 'Sports', 'Sports-Men', 'Sports-Women'],
  military: [
    'Family',
    'Military',
    'Phrase',
    'Sports',
    'Sports-Men',
    'Sports-Women'
  ],
  firstResponder: [
    'Family',
    'Military',
    'Phrase',
    'Sports',
    'Sports-Men',
    'Sports-Women'
  ],
  outdoor: ['Family', 'Phrase', 'Sports', 'Sports-Men', 'Sports-Women']
}

export const activityOrderBySchoolType = {
  default: ['School', 'Sports'],

  [storeKinds.ELEMENTARY]: activityOrders.school,
  [storeKinds.HIGH]: activityOrders.school,
  [storeKinds.MIDDLE]: activityOrders.school,

  [storeKinds.TEAM2]: activityOrders.team,
  [storeKinds.TEAM]: activityOrders.team,
  [storeKinds.VINTAGE]: activityOrders.team,

  [storeKinds.ACADEMY]: activityOrders.college,
  [storeKinds.COLLEGE]: activityOrders.college,
  [storeKinds.COLLEGE_TM]: activityOrders.college,
  [storeKinds.UNIVERSITY]: activityOrders.college,
  [storeKinds.UNIVERSITY_TM]: activityOrders.college,

  [storeKinds.FRATERNITY]: activityOrders.greek,
  [storeKinds.GREEK]: activityOrders.greek,
  [storeKinds.SORORITY]: activityOrders.greek,

  [storeKinds.AIRFORCE]: activityOrders.military,
  [storeKinds.ARMY]: activityOrders.military,
  [storeKinds.COASTGUARD]: activityOrders.military,
  [storeKinds.MARINES]: activityOrders.military,
  [storeKinds.MILITARY]: activityOrders.military,
  [storeKinds.NATIONALGUARD]: activityOrders.military,
  [storeKinds.NAVY]: activityOrders.military,

  [storeKinds.FEDERAL]: activityOrders.military,
  [storeKinds.FIRE]: activityOrders.military,
  [storeKinds.MARSHAL]: activityOrders.military,
  [storeKinds.POLICE]: activityOrders.military,
  [storeKinds.SHERIFF]: activityOrders.military,
  [storeKinds.TROOPER]: activityOrders.military,

  [storeKinds.ADVENTURE]: activityOrders.outdoor,
  [storeKinds.DESTINATION]: activityOrders.outdoor,
  [storeKinds.PARKSANDREC]: activityOrders.outdoor
}
